/**
 * Equalize fragrance note item widths to the widest note (desktop only).
 * Caps at CSS max-width (135px). Below 750px, CSS grid handles layout.
 */
(function () {
  var DESKTOP_MIN = 750;
  var DESKTOP_MAX_WIDTH = 135;

  function clearItemWidths(root) {
    root.querySelectorAll('.zaoud-fragrance-notes__item').forEach(function (el) {
      el.style.width = '';
    });
  }

  function getDesktopMaxWidth(el) {
    var raw = window.getComputedStyle(el).maxWidth;
    var parsed = parseFloat(raw);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : DESKTOP_MAX_WIDTH;
  }

  function equalizeNoteBlocks(root) {
    var items = root.querySelectorAll('.zaoud-fragrance-notes__item');
    if (!items.length) return;

    clearItemWidths(root);

    if (window.matchMedia('(max-width: ' + (DESKTOP_MIN - 1) + 'px)').matches) {
      return;
    }

    var cap = getDesktopMaxWidth(items[0]);
    var max = 0;
    items.forEach(function (el) {
      max = Math.max(max, el.getBoundingClientRect().width);
    });

    if (max <= 0) return;

    var width = Math.ceil(Math.min(max, cap)) + 'px';
    items.forEach(function (el) {
      el.style.width = width;
    });
  }

  function equalizeAll() {
    document.querySelectorAll('.zaoud-fragrance-notes-section').forEach(equalizeNoteBlocks);
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeAll, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', equalizeAll);
  } else {
    equalizeAll();
  }

  window.addEventListener('resize', onResize);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(equalizeAll);
  }
})();
